import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Output, Input, NgModule } from '@angular/core';
import * as i1 from 'base-create-template-library';
import { BaseCreateTemplateLibraryService } from 'base-create-template-library';
import * as i2 from 'ngx-toastr';
import * as i3 from '@ngrx/store';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i5 from '@angular/common';
import * as i6 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i7 from '@progress/kendo-angular-toolbar';
import * as i8 from 'primeng/button';
import * as i9 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PlaceHolderLibraryModule } from 'place-holder-library';

class CreateTemplateLibraryService {
    constructor() { }
}
CreateTemplateLibraryService.ɵfac = function CreateTemplateLibraryService_Factory(t) { return new (t || CreateTemplateLibraryService)(); };
CreateTemplateLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: CreateTemplateLibraryService, factory: CreateTemplateLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTemplateLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["createtemplatelibraryheaderupload"];
const _c1 = ["createtemplatelibrarybodyupload"];
const _c2 = ["createtemplatelibraryfooterupload"];
const _c3 = ["createtemplatelibraryheaderkendoeditor"];
const _c4 = ["createtemplatelibrarybodykendoeditor"];
const _c5 = ["createtemplatelibraryfooterkendoeditor"];
const _c6 = ["createTemplateForm"];
function CreateTemplateLibraryComponent_u_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "u", 7);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_u_4_Template_u_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleBack(); });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, " arrow_back_ios ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "Select Pre-defined Template ");
    i0.ɵɵelementEnd();
} }
function CreateTemplateLibraryComponent_div_10_kendo_editor_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-editor", 14);
    i0.ɵɵlistener("valueChange", function CreateTemplateLibraryComponent_div_10_kendo_editor_6_Template_kendo_editor_valueChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.aiGeneratedValue = $event; })("valueChange", function CreateTemplateLibraryComponent_div_10_kendo_editor_6_Template_kendo_editor_valueChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.templateAIGeneratedValueChange($event); });
    i0.ɵɵelementStart(1, "kendo-toolbar");
    i0.ɵɵelementStart(2, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(3, "kendo-toolbar-button", 15);
    i0.ɵɵelement(4, "kendo-toolbar-button", 16);
    i0.ɵɵelement(5, "kendo-toolbar-button", 17);
    i0.ɵɵelement(6, "kendo-toolbar-button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(8, "kendo-toolbar-button", 19);
    i0.ɵɵelement(9, "kendo-toolbar-button", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(11, "kendo-toolbar-button", 21);
    i0.ɵɵelement(12, "kendo-toolbar-button", 22);
    i0.ɵɵelement(13, "kendo-toolbar-button", 23);
    i0.ɵɵelement(14, "kendo-toolbar-button", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "kendo-toolbar-dropdownlist", 25);
    i0.ɵɵelement(16, "kendo-toolbar-dropdownlist", 26);
    i0.ɵɵelement(17, "kendo-toolbar-dropdownlist", 27);
    i0.ɵɵelement(18, "kendo-toolbar-colorpicker", 28);
    i0.ɵɵelement(19, "kendo-toolbar-colorpicker", 29);
    i0.ɵɵelementStart(20, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(21, "kendo-toolbar-button", 30);
    i0.ɵɵelement(22, "kendo-toolbar-button", 31);
    i0.ɵɵelement(23, "kendo-toolbar-button", 32);
    i0.ɵɵelement(24, "kendo-toolbar-button", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "kendo-toolbar-button", 34);
    i0.ɵɵelement(26, "kendo-toolbar-button", 35);
    i0.ɵɵelementStart(27, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(28, "kendo-toolbar-button", 36);
    i0.ɵɵelement(29, "kendo-toolbar-button", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(31, "kendo-toolbar-button", 38);
    i0.ɵɵelement(32, "kendo-toolbar-button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "kendo-toolbar-button", 40);
    i0.ɵɵelement(34, "kendo-toolbar-button", 41);
    i0.ɵɵelement(35, "kendo-toolbar-button", 42);
    i0.ɵɵelement(36, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(37, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(38, "kendo-toolbar-button", 43);
    i0.ɵɵelement(39, "kendo-toolbar-button", 44);
    i0.ɵɵelement(40, "kendo-toolbar-button", 45);
    i0.ɵɵelement(41, "kendo-toolbar-button", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(43, "kendo-toolbar-button", 47);
    i0.ɵɵelement(44, "kendo-toolbar-button", 48);
    i0.ɵɵelement(45, "kendo-toolbar-button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(47, "kendo-toolbar-button", 50);
    i0.ɵɵelement(48, "kendo-toolbar-button", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r6.aiGeneratedValue);
} }
function CreateTemplateLibraryComponent_div_10_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelementStart(1, "div", 53);
    i0.ɵɵelementStart(2, "button", 54);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_10_div_7_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.handleSaveTemplate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵelementStart(4, "button", 56);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_10_div_7_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.handleCancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateTemplateLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "input", 10);
    i0.ɵɵlistener("ngModelChange", function CreateTemplateLibraryComponent_div_10_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.searchText = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 11);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_10_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.getAIGeneratedValue(); });
    i0.ɵɵtext(4, "Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtemplate(6, CreateTemplateLibraryComponent_div_10_kendo_editor_6_Template, 49, 1, "kendo-editor", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CreateTemplateLibraryComponent_div_10_div_7_Template, 5, 0, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r2.searchText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.aiGeneratedValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.aiGeneratedValue);
} }
function CreateTemplateLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 57);
    i0.ɵɵelementStart(2, "div", 58);
    i0.ɵɵelementStart(3, "h5", 59);
    i0.ɵɵtext(4, "Enter details for Header Section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 60);
    i0.ɵɵelementStart(6, "kendo-editor", 61, 62);
    i0.ɵɵlistener("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_6_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.template.header = $event; })("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_6_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.createtemplatelibraryheaderValueChange($event); });
    i0.ɵɵelementStart(8, "kendo-toolbar");
    i0.ɵɵelementStart(9, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(10, "kendo-toolbar-button", 15);
    i0.ɵɵelement(11, "kendo-toolbar-button", 16);
    i0.ɵɵelement(12, "kendo-toolbar-button", 17);
    i0.ɵɵelement(13, "kendo-toolbar-button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(15, "kendo-toolbar-button", 19);
    i0.ɵɵelement(16, "kendo-toolbar-button", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(18, "kendo-toolbar-button", 21);
    i0.ɵɵelement(19, "kendo-toolbar-button", 22);
    i0.ɵɵelement(20, "kendo-toolbar-button", 23);
    i0.ɵɵelement(21, "kendo-toolbar-button", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "kendo-toolbar-dropdownlist", 25);
    i0.ɵɵelement(23, "kendo-toolbar-dropdownlist", 26);
    i0.ɵɵelement(24, "kendo-toolbar-dropdownlist", 27);
    i0.ɵɵelement(25, "kendo-toolbar-colorpicker", 28);
    i0.ɵɵelement(26, "kendo-toolbar-colorpicker", 29);
    i0.ɵɵelementStart(27, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(28, "kendo-toolbar-button", 30);
    i0.ɵɵelement(29, "kendo-toolbar-button", 31);
    i0.ɵɵelement(30, "kendo-toolbar-button", 32);
    i0.ɵɵelement(31, "kendo-toolbar-button", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(32, "kendo-toolbar-button", 34);
    i0.ɵɵelement(33, "kendo-toolbar-button", 35);
    i0.ɵɵelementStart(34, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(35, "kendo-toolbar-button", 36);
    i0.ɵɵelement(36, "kendo-toolbar-button", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(38, "kendo-toolbar-button", 38);
    i0.ɵɵelement(39, "kendo-toolbar-button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "kendo-toolbar-button", 40);
    i0.ɵɵelement(41, "kendo-toolbar-button", 41);
    i0.ɵɵelement(42, "kendo-toolbar-button", 42);
    i0.ɵɵelement(43, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(44, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(45, "kendo-toolbar-button", 43);
    i0.ɵɵelement(46, "kendo-toolbar-button", 44);
    i0.ɵɵelement(47, "kendo-toolbar-button", 45);
    i0.ɵɵelement(48, "kendo-toolbar-button", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(50, "kendo-toolbar-button", 47);
    i0.ɵɵelement(51, "kendo-toolbar-button", 48);
    i0.ɵɵelement(52, "kendo-toolbar-button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(54, "kendo-toolbar-button", 50);
    i0.ɵɵelement(55, "kendo-toolbar-button", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(56, "kendo-toolbar-button", 63);
    i0.ɵɵelementStart(57, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(58, "kendo-toolbar-button", 64);
    i0.ɵɵelementStart(59, "kendo-toolbar-button", 65);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_11_Template_kendo_toolbar_button_click_59_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.createtemplatelibraryheaderimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(60, "app-upload-image-dialog", 66, 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "div", 68);
    i0.ɵɵelementStart(63, "div", 69);
    i0.ɵɵelementStart(64, "h5", 59);
    i0.ɵɵtext(65, "Enter details for Content Section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(66, "div", 60);
    i0.ɵɵelementStart(67, "kendo-editor", 70, 71);
    i0.ɵɵlistener("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_67_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.template.body = $event; })("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_67_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.createtemplatelibrarybodyValueChange($event); });
    i0.ɵɵelementStart(69, "kendo-toolbar");
    i0.ɵɵelementStart(70, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(71, "kendo-toolbar-button", 15);
    i0.ɵɵelement(72, "kendo-toolbar-button", 16);
    i0.ɵɵelement(73, "kendo-toolbar-button", 17);
    i0.ɵɵelement(74, "kendo-toolbar-button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(76, "kendo-toolbar-button", 19);
    i0.ɵɵelement(77, "kendo-toolbar-button", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(79, "kendo-toolbar-button", 21);
    i0.ɵɵelement(80, "kendo-toolbar-button", 22);
    i0.ɵɵelement(81, "kendo-toolbar-button", 23);
    i0.ɵɵelement(82, "kendo-toolbar-button", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(83, "kendo-toolbar-dropdownlist", 25);
    i0.ɵɵelement(84, "kendo-toolbar-dropdownlist", 26);
    i0.ɵɵelement(85, "kendo-toolbar-dropdownlist", 27);
    i0.ɵɵelement(86, "kendo-toolbar-colorpicker", 28);
    i0.ɵɵelement(87, "kendo-toolbar-colorpicker", 29);
    i0.ɵɵelementStart(88, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(89, "kendo-toolbar-button", 30);
    i0.ɵɵelement(90, "kendo-toolbar-button", 31);
    i0.ɵɵelement(91, "kendo-toolbar-button", 32);
    i0.ɵɵelement(92, "kendo-toolbar-button", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(93, "kendo-toolbar-button", 34);
    i0.ɵɵelement(94, "kendo-toolbar-button", 35);
    i0.ɵɵelementStart(95, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(96, "kendo-toolbar-button", 36);
    i0.ɵɵelement(97, "kendo-toolbar-button", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(98, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(99, "kendo-toolbar-button", 38);
    i0.ɵɵelement(100, "kendo-toolbar-button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(101, "kendo-toolbar-button", 40);
    i0.ɵɵelement(102, "kendo-toolbar-button", 41);
    i0.ɵɵelement(103, "kendo-toolbar-button", 42);
    i0.ɵɵelement(104, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(105, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(106, "kendo-toolbar-button", 43);
    i0.ɵɵelement(107, "kendo-toolbar-button", 44);
    i0.ɵɵelement(108, "kendo-toolbar-button", 45);
    i0.ɵɵelement(109, "kendo-toolbar-button", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(110, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(111, "kendo-toolbar-button", 47);
    i0.ɵɵelement(112, "kendo-toolbar-button", 48);
    i0.ɵɵelement(113, "kendo-toolbar-button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(114, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(115, "kendo-toolbar-button", 50);
    i0.ɵɵelement(116, "kendo-toolbar-button", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(117, "kendo-toolbar-button", 63);
    i0.ɵɵelementStart(118, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(119, "kendo-toolbar-button", 64);
    i0.ɵɵelementStart(120, "kendo-toolbar-button", 65);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_11_Template_kendo_toolbar_button_click_120_listener() { i0.ɵɵrestoreView(_r24); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.createtemplatelibrarybodyimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(121, "app-upload-image-dialog", 66, 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(123, "div", 73);
    i0.ɵɵelementStart(124, "div", 69);
    i0.ɵɵelementStart(125, "h5", 59);
    i0.ɵɵtext(126, "Enter details for Footer Section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "div", 60);
    i0.ɵɵelementStart(128, "kendo-editor", 74, 75);
    i0.ɵɵlistener("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_128_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.template.footer = $event; })("valueChange", function CreateTemplateLibraryComponent_div_11_Template_kendo_editor_valueChange_128_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.createtemplatelibraryfooterValueChange($event); });
    i0.ɵɵelementStart(130, "kendo-toolbar");
    i0.ɵɵelementStart(131, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(132, "kendo-toolbar-button", 15);
    i0.ɵɵelement(133, "kendo-toolbar-button", 16);
    i0.ɵɵelement(134, "kendo-toolbar-button", 17);
    i0.ɵɵelement(135, "kendo-toolbar-button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(136, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(137, "kendo-toolbar-button", 19);
    i0.ɵɵelement(138, "kendo-toolbar-button", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(139, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(140, "kendo-toolbar-button", 21);
    i0.ɵɵelement(141, "kendo-toolbar-button", 22);
    i0.ɵɵelement(142, "kendo-toolbar-button", 23);
    i0.ɵɵelement(143, "kendo-toolbar-button", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(144, "kendo-toolbar-dropdownlist", 25);
    i0.ɵɵelement(145, "kendo-toolbar-dropdownlist", 26);
    i0.ɵɵelement(146, "kendo-toolbar-dropdownlist", 27);
    i0.ɵɵelement(147, "kendo-toolbar-colorpicker", 28);
    i0.ɵɵelement(148, "kendo-toolbar-colorpicker", 29);
    i0.ɵɵelementStart(149, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(150, "kendo-toolbar-button", 30);
    i0.ɵɵelement(151, "kendo-toolbar-button", 31);
    i0.ɵɵelement(152, "kendo-toolbar-button", 32);
    i0.ɵɵelement(153, "kendo-toolbar-button", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(154, "kendo-toolbar-button", 34);
    i0.ɵɵelement(155, "kendo-toolbar-button", 35);
    i0.ɵɵelementStart(156, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(157, "kendo-toolbar-button", 36);
    i0.ɵɵelement(158, "kendo-toolbar-button", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(159, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(160, "kendo-toolbar-button", 38);
    i0.ɵɵelement(161, "kendo-toolbar-button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(162, "kendo-toolbar-button", 40);
    i0.ɵɵelement(163, "kendo-toolbar-button", 41);
    i0.ɵɵelement(164, "kendo-toolbar-button", 42);
    i0.ɵɵelement(165, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(166, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(167, "kendo-toolbar-button", 43);
    i0.ɵɵelement(168, "kendo-toolbar-button", 44);
    i0.ɵɵelement(169, "kendo-toolbar-button", 45);
    i0.ɵɵelement(170, "kendo-toolbar-button", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(171, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(172, "kendo-toolbar-button", 47);
    i0.ɵɵelement(173, "kendo-toolbar-button", 48);
    i0.ɵɵelement(174, "kendo-toolbar-button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(175, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(176, "kendo-toolbar-button", 50);
    i0.ɵɵelement(177, "kendo-toolbar-button", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(178, "kendo-toolbar-button", 63);
    i0.ɵɵelementStart(179, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(180, "kendo-toolbar-button", 64);
    i0.ɵɵelementStart(181, "kendo-toolbar-button", 65);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_11_Template_kendo_toolbar_button_click_181_listener() { i0.ɵɵrestoreView(_r24); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.createtemplatelibraryfooterimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(182, "app-upload-image-dialog", 66, 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(184, "div", 52);
    i0.ɵɵelementStart(185, "div", 53);
    i0.ɵɵelementStart(186, "button", 77);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_11_Template_button_click_186_listener() { i0.ɵɵrestoreView(_r24); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.handleSaveTemplate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(187, "div", 55);
    i0.ɵɵelementStart(188, "button", 56);
    i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_div_11_Template_button_click_188_listener() { i0.ɵɵrestoreView(_r24); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.handleCancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r17 = i0.ɵɵreference(7);
    const _r19 = i0.ɵɵreference(68);
    const _r21 = i0.ɵɵreference(129);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r3.template.header);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r17);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", ctx_r3.template.body);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r19);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", ctx_r3.template.footer);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r21);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r3.disabledControls);
} }
class CreateTemplateLibraryComponent extends BaseCreateTemplateLibraryService {
    constructor(apiService, toastr, store) {
        super(apiService, toastr, store);
        this.apiService = apiService;
        this.toastr = toastr;
        this.store = store;
        this.isAIGenerated = false;
        this.onDialogClose = new EventEmitter();
    }
    switchToManualOrAI(val) {
        this.isAIGenerated = val;
    }
    templateAIGeneratedValueChange(value) {
        this.aiGeneratedValue = value;
    }
    getAIGeneratedValue() {
        this.apiService.getAIGeneratedValue(this.searchText).subscribe((val) => {
            var _a;
            let textArray = (_a = val.data) === null || _a === void 0 ? void 0 : _a.split('/n');
            let p = document.createElement('div');
            p.innerText = textArray.join('<br>');
            //console.log(p.outerText);
            this.aiGeneratedValue = p.outerHTML.toString();
        });
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.createTemplateForm = this.createTemplateForm;
        super.ngAfterViewInit();
    }
    createtemplatelibraryheaderimageuploaddialog() {
        this.createtemplatelibraryheaderupload.open();
    }
    createtemplatelibrarybodyimageuploaddialog() {
        this.createtemplatelibrarybodyupload.open();
    }
    createtemplatelibraryfooterimageuploaddialog() {
        this.createtemplatelibraryfooterupload.open();
    }
    createtemplatelibraryheaderValueChange(value) {
        this.template.header = value;
    }
    createtemplatelibrarybodyValueChange(value) {
        this.template.body = value;
    }
    createtemplatelibraryfooterValueChange(value) {
        this.template.footer = value;
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
CreateTemplateLibraryComponent.ɵfac = function CreateTemplateLibraryComponent_Factory(t) { return new (t || CreateTemplateLibraryComponent)(i0.ɵɵdirectiveInject(i1.APICreateTemplate), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.Store)); };
CreateTemplateLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateTemplateLibraryComponent, selectors: [["create-template-library"]], viewQuery: function CreateTemplateLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
        i0.ɵɵviewQuery(_c3, 1);
        i0.ɵɵviewQuery(_c4, 1);
        i0.ɵɵviewQuery(_c5, 1);
        i0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibraryheaderupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibrarybodyupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibraryfooterupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibraryheaderkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibrarybodykendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createtemplatelibraryfooterkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createTemplateForm = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { createtemplatelibraryheaderkendoeditor: "createtemplatelibraryheaderkendoeditor", createtemplatelibrarybodykendoeditor: "createtemplatelibrarybodykendoeditor", createtemplatelibraryfooterkendoeditor: "createtemplatelibraryfooterkendoeditor", onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 5, consts: [[1, "col-md-12"], ["createTemplateForm", "ngForm"], [1, "col-md-12", "pl-0", "row", "d-flex", "align-items-center", "mb-2", 2, "cursor", "pointer", "color", "rgb(75, 197, 238)"], ["class", "heading", 3, "click", 4, "ngIf"], [1, "d-flex", "align-items-center", "justify-content-around", 2, "background-color", "#eee", "cursor", "pointer"], [1, "m-0", "w-100", "p-3", "text-center", 3, "ngClass", "click"], [4, "ngIf"], [1, "heading", 3, "click"], [1, "material-icons", "align-middle", 2, "font-size", "inherit"], [1, "d-flex", "align-items-center", "mt-4"], ["type", "text", "placeholder", "Ask here...", "name", "searchText", 3, "ngModel", "ngModelChange"], [1, "btn", "btn-primary", 3, "click"], ["class", "mb-3", "style", "height: 800px", 3, "value", "valueChange", 4, "ngIf"], ["class", "row p-0 pb-2", 4, "ngIf"], [1, "mb-3", 2, "height", "800px", 3, "value", "valueChange"], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], [1, "row", "p-0", "pb-2"], [1, "mr-3", "p-0"], ["type", "button", "label", "SAVE & PREVIEW", "title", "SAVE & PREVIEW", "pButton", "", 1, "p-button-info", 3, "click"], [1, "p-0"], ["type", "button", "label", "CANCEL", "title", "CANCEL", "pButton", "", 1, "p-button-info", 3, "click"], [1, "row", "col-md-12", "pb-4", "p-0", "title", "template-editor-maxwidth", "headerEditor"], [1, "col-md-12", "p-0", "mt-3"], [1, "h5-font-size"], [1, "col-md-12", "p-0", "letter-textarea"], ["name", "createtemplatelibraryheaderTextContent", 2, "height", "400px", 3, "value", "valueChange"], ["createtemplatelibraryheaderkendoeditor", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["createtemplatelibraryheaderupload", ""], [1, "row", "col-md-12", "p-0", "pb-4", "title", "template-editor-maxwidth", "contentEditor"], [1, "col-md-12", "p-0"], ["name", "createtemplatelibrarybodyTextContent", 2, "height", "400px", 3, "value", "valueChange"], ["createtemplatelibrarybodykendoeditor", ""], ["createtemplatelibrarybodyupload", ""], [1, "row", "col-md-12", "p-0", "pb-4", "title", "template-editor-maxwidth", "footerEditor"], ["name", "createtemplatelibraryfooterTextContent", 2, "height", "400px", 3, "value", "valueChange"], ["createtemplatelibraryfooterkendoeditor", ""], ["createtemplatelibraryfooterupload", ""], ["type", "button", "label", "SAVE & PREVIEW", "title", "SAVE & PREVIEW", "pButton", "", 1, "p-button-info", 3, "disabled", "click"]], template: function CreateTemplateLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", null, 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtemplate(4, CreateTemplateLibraryComponent_u_4_Template, 4, 0, "u", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "p", 5);
        i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_Template_p_click_6_listener() { return ctx.switchToManualOrAI(false); });
        i0.ɵɵtext(7, "MANUAL");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "p", 5);
        i0.ɵɵlistener("click", function CreateTemplateLibraryComponent_Template_p_click_8_listener() { return ctx.switchToManualOrAI(true); });
        i0.ɵɵtext(9, "AI GENERATED");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, CreateTemplateLibraryComponent_div_10_Template, 8, 3, "div", 6);
        i0.ɵɵtemplate(11, CreateTemplateLibraryComponent_div_11_Template, 189, 7, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.letterType === "COVLTR");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", !ctx.isAIGenerated ? "active bg-white border-bottom-active" : "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.isAIGenerated ? "active bg-white border-bottom-active" : "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAIGenerated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isAIGenerated);
    } }, directives: [i4.ɵangular_packages_forms_forms_ba, i4.NgControlStatusGroup, i4.NgForm, i5.NgIf, i5.NgClass, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i6.EditorComponent, i7.ToolBarComponent, i7.ToolBarButtonGroupComponent, i7.ToolBarButtonComponent, i6.EditorBoldButtonDirective, i6.EditorItalicButtonDirective, i6.EditorUnderlineButtonDirective, i6.EditorStrikethroughButtonDirective, i6.EditorSubscriptButtonDirective, i6.EditorSuperscriptButtonDirective, i6.EditorAlignLeftButtonDirective, i6.EditorAlignCenterButtonDirective, i6.EditorAlignRightButtonDirective, i6.EditorAlignJustifyButtonDirective, i6.EditorFormatComponent, i6.EditorFontSizeComponent, i6.EditorFontFamilyComponent, i6.EditorColorPickerComponent, i6.EditorForeColorDirective, i6.EditorBackColorDirective, i6.EditorInsertUnorderedListButtonDirective, i6.EditorInsertOrderedListButtonDirective, i6.EditorIndentButtonDirective, i6.EditorOutdentButtonDirective, i6.EditorBlockquoteDirective, i6.EditorSelectAllButtonDirective, i6.EditorUndoButtonDirective, i6.EditorRedoButtonDirective, i6.EditorCreateLinkButtonDirective, i6.EditorUnlinkButtonDirective, i6.EditorInsertFileButtonDirective, i6.EditorViewSourceButtonDirective, i6.EditorCleanFormattingButtonDirective, i6.EditorInsertTableButtonComponent, i6.EditorAddColumnBeforeButtonDirective, i6.EditorAddColumnAfterButtonDirective, i6.EditorAddRowBeforeButtonDirective, i6.EditorAddRowAfterButtonDirective, i6.EditorDeleteColumnButtonDirective, i6.EditorDeleteRowButtonDirective, i6.EditorDeleteTableButtonDirective, i6.EditorMergeCellsButtonDirective, i6.EditorSplitCellButtonDirective, i8.ButtonDirective, i6.EditorPrintDirective, i6.EditorInsertImageButtonDirective, i9.UploadImageDialogComponent], styles: [".step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.h5-font-size[_ngcontent-%COMP%]{font-size:16px!important}.border-bottom-active[_ngcontent-%COMP%]{border-bottom:4px solid #08a3db!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTemplateLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'create-template-library',
                templateUrl: 'create-template-library.component.html',
                styleUrls: ['create-template-library.component.scss']
            }]
    }], function () { return [{ type: i1.APICreateTemplate }, { type: i2.ToastrService }, { type: i3.Store }]; }, { createtemplatelibraryheaderupload: [{
            type: ViewChild,
            args: ["createtemplatelibraryheaderupload"]
        }], createtemplatelibrarybodyupload: [{
            type: ViewChild,
            args: ["createtemplatelibrarybodyupload"]
        }], createtemplatelibraryfooterupload: [{
            type: ViewChild,
            args: ["createtemplatelibraryfooterupload"]
        }], createtemplatelibraryheaderkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["createtemplatelibraryheaderkendoeditor"]
        }], createtemplatelibrarybodykendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["createtemplatelibrarybodykendoeditor"]
        }], createtemplatelibraryfooterkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["createtemplatelibraryfooterkendoeditor"]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], createTemplateForm: [{
            type: ViewChild,
            args: ['createTemplateForm', { static: true }]
        }] }); })();

class CreateTemplateLibraryModule {
}
CreateTemplateLibraryModule.ɵfac = function CreateTemplateLibraryModule_Factory(t) { return new (t || CreateTemplateLibraryModule)(); };
CreateTemplateLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: CreateTemplateLibraryModule });
CreateTemplateLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseCreateTemplateLibraryService], imports: [[
            PlaceHolderLibraryModule,
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FormsModule,
            EditorModule,
            EditorLibraryModule
            // FroalaEditorModule.forRoot(),
            // FroalaViewModule.forRoot(),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CreateTemplateLibraryModule, { declarations: [CreateTemplateLibraryComponent], imports: [PlaceHolderLibraryModule,
        PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FormsModule,
        EditorModule,
        EditorLibraryModule
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot(),
    ], exports: [CreateTemplateLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTemplateLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [CreateTemplateLibraryComponent],
                imports: [
                    PlaceHolderLibraryModule,
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FormsModule,
                    EditorModule,
                    EditorLibraryModule
                    // FroalaEditorModule.forRoot(),
                    // FroalaViewModule.forRoot(),
                ],
                providers: [BaseCreateTemplateLibraryService],
                exports: [CreateTemplateLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of create-template-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CreateTemplateLibraryComponent, CreateTemplateLibraryModule, CreateTemplateLibraryService };
//# sourceMappingURL=create-template-library.js.map
